<!-- Remove action template (for representatives) -->
<ng-template #rowActionTemplate let-onClick="onClick">
  <button [buttonType]="'regular'" [buttonTheme]="'light'" style="align-self: center"
    (click)="onClick(); $event.stopPropagation()">
    <ng-icon size="18" strokeWidth="2" [name]="'trash'" color="red"></ng-icon>
  </button>
</ng-template>

<!-- Approve action template (for supervisors) -->
<ng-template #approveActionTemplate let-onClick="onClick">
  <button [buttonType]="'regular'" [buttonTheme]="'light'" style="align-self: center"
    (click)="onClick(); $event.stopPropagation()">
    <ng-icon size="18" strokeWidth="2" [name]="'check'" color="green"></ng-icon>
  </button>
</ng-template>

<!-- Reject action template (for supervisors) -->
<ng-template #rejectActionTemplate let-onClick="onClick">
  <button [buttonType]="'regular'" [buttonTheme]="'light'" style="align-self: center"
    (click)="onClick(); $event.stopPropagation()">
    <ng-icon size="18" strokeWidth="2" [name]="'x'" color="red"></ng-icon>
  </button>
</ng-template>

<app-tab-layout [loading]="loading()" [error]="error">
  @if(initialized()) {
  <app-api-table #draftTable [endpoint]="tableEndpoint" name="Editing Draft" [extraBody]="tableExtraBody"
    [skipFilters]="true" [actionCol]="actionColConfig">
  </app-api-table>

  <!-- Accept All button for supervisors -->
  @if(canShowAcceptAllButton()) {
  <button buttonTheme="primary" buttonType="regular" buttonSize="sm" class="mt-3" (click)="handleAcceptAll()">
    {{ dictionaryService.get('AcceptAll') }}
  </button>
  }
  }
</app-tab-layout>

<!-- Single/Multiple action confirmation modal -->
<app-modal [title]="getModalTitle()" size="xl" [opened]="confirmationModal()" (closeTrigger)="cancelAction()">
  <h6>
    @if(itemsToAction.length === 1) {
    <ng-container>
      {{ getConfirmationMessage() }}
      <strong> {{ itemsToAction[0].value['Name'] }}</strong>
    </ng-container>
    } @else {
    <ng-container>
      {{ getConfirmationMessage() }}
    </ng-container>
    }
  </h6>

  <div class="buttons mt-2">
    <button [buttonTheme]="modalAction === 'approve' ? 'primary' : 'danger'" buttonType="regular"
      (click)="confirmAction()">
      {{ dictionaryService.get('Confirm') }}
    </button>
    <button buttonTheme="light" buttonType="regular" (click)="cancelAction()">
      {{ dictionaryService.get('Cancel') }}
    </button>
  </div>
</app-modal>

<!-- Accept All confirmation modal (supervisors) -->
<app-modal [title]="dictionaryService.get('Confirmation')" size="xl" [opened]="acceptAllModal()"
  (closeTrigger)="cancelAcceptAll()">
  <h6>{{ dictionaryService.get('AcceptAllConfirmation') }}</h6>

  <div class="buttons mt-2">
    <button buttonTheme="primary" buttonType="regular" (click)="confirmAcceptAll()">
      {{ dictionaryService.get('Confirm') }}
    </button>
    <button buttonTheme="light" buttonType="regular" (click)="cancelAcceptAll()">
      {{ dictionaryService.get('Cancel') }}
    </button>
  </div>
</app-modal>